import planApi from "../../../../api/planApi";

/**
 * base64转文件, 兼容IOS/MAC等, 放弃@dyb881/file
 * @param base64
 * @param fileName
 * @returns {Promise<Blob>}
 * @private
 */
export const imgBase64ToFile = (base64, fileName) => {
    const data = base64.split(",");
    const type = data[0].slice(5, -7);
    const ext = type.split("/")[1];
    const bstr = atob(data[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    let blob = new Blob([u8arr], { type: type });
    blob.lastModifiedDate = new Date();
    blob.name = `${fileName}.${ext}`;
    return Promise.resolve(blob);
};

// 获取培训类型标题
export const getTrainTypeTitle = (val) => {
    if (val && val.item && val.item.isMeeting) {
        const isMeeting = val.item.isMeeting;
        if (isMeeting) {
            return "会议";
        } else {
            return "培训";
        }
    }
    return "培训";
};

// 获取需要验证人员的信息
export const loadSignOutValidUser = (row, cb) => {
    // cb && cb({ isValid: true });
    // return;
    const that = this;
    const params = {
        // hoursRecordId: row.item.hoursRecordId,
        offlineRecordId: row ? row.item.offlineRecordId : "",
    };
    planApi.getSignOutTaskData(params).then((response) => {
        const { success, data } = response;
        if (success && data) {
            cb && cb(data);
        } else {
            cb && cb(null, response);
        }
    });
};
